import compat from 'preact/compat';
import { IMenuItem, IMenuState } from './types';

export const transformMenuData = ( data: Record<string, IMenuItem> ) => {
	return Object.values( data ).map( ( { children, ...item } ) => {
		return { ...item, hasChildren: !!children };
	} );
};

export const setActiveID = (
	depth: number,
	menuItemID,
	setState: compat.SetStateAction<Array<IMenuState>>,
) => {
	setState( ( prevState ) => {
		const newColumns = [ ...prevState ];
		newColumns[depth] = {
			...prevState[depth],
			activeID: parseInt( menuItemID ),
		};
		return newColumns;
	} );
};

export const setSubmenuItems = (
	depth: number,
	subMenuItems,
	setState: compat.SetStateAction<Array<IMenuState>>,
) => {
	if ( ! subMenuItems ) return;

	setState( ( prevState ) => {
		const newColumns = [ ...prevState ];
		newColumns[depth + 1] = {
			...newColumns[depth + 1],
			activeID: -1,
			items: transformMenuData( subMenuItems ),
			depth: depth + 1,
		};
		return newColumns;
	} );
};

export const setSubmenuParent = (
	depth: number,
	subMenuBackItem: IMenuItem,
	setState: compat.SetStateAction<Array<IMenuState>>,
) => {
	if ( ! subMenuBackItem ) return;

	setState( ( prevState ) => {
		const newColumns = [ ...prevState ];
		newColumns[depth + 1].parentItem = subMenuBackItem;
		newColumns[depth + 1].hasOverviewItem =
			( subMenuBackItem?.object !== 'custom' );
		return newColumns;
	} );
};

export const resetColumnsFromDepth = ( depth, setState, toggleDirection ) => {
	setState( ( prevState ) => {
		const newColumns = [ ...prevState ];

		let depthIndex = toggleDirection === 'open'
			? depth + 2
			: depth + 1;

		for ( ; depthIndex < prevState.length; depthIndex++ ) {
			newColumns[depthIndex] = {
				...newColumns[depthIndex],
				activeID: -1,
				items: [],
				depth: depthIndex,
				parentItem: null,
			};
		}

		return newColumns;
	} );
};

export const findPathByPageId = (
	menuTree: IMenuItem,
	pageId: number,
	path: number[] = [],
): number[] => {

	//
	if ( parseInt( menuTree.object_id ) === pageId ) {
		return path;
	}
	if ( ! menuTree.children ) {
		return [];
	}
	for ( let i = 0; i < menuTree.children.length; i++ ) {
		const recursivePath = findPathByPageId( menuTree.children[i], pageId, [ ...path, menuTree.children[i].ID ] );
		if ( ! recursivePath || recursivePath.length === 0 ) continue;
		return recursivePath;
	}
	return null;
};

export const isVerticallyScrollable = ( element: HTMLElement ): boolean => {
	const hasScrollableContent = element.scrollHeight > element.clientHeight;
	const overflowYStyle = window.getComputedStyle( element ).overflowY;
	const isOverflowHidden = overflowYStyle.indexOf( 'hidden' ) !== -1;

	return hasScrollableContent && !isOverflowHidden;
};

export const getHeightPriorToMenuOpen = ( element ) => {
	element = element.cloneNode( true );
	element.style.visibility = "hidden";
	document.body.appendChild( element );
	const height = element.offsetHeight + 0;
	document.body.removeChild( element );
	element.style.visibility = "visible";
	return height;
};
